module.exports = __webpack_public_path__ + "img/chuyu_icon.2caa5251.png";